import $ from 'jquery';
import mapboxgl from 'mapbox-gl';

const marker = $('#marker');

if($('.mapbox-single')) {

    if ( marker.attr( 'data-lng' ) ) {

        var markerPosition = new mapboxgl.LngLat( marker.attr( 'data-lng' ), marker.attr( 'data-lat' ) );

        mapboxgl.accessToken = 'pk.eyJ1IjoiYmxhY2tkZXNrIiwiYSI6ImNrdWNieml4ZTB6M2oyb2xtMHF5dDBqMmoifQ.n7d-bn9GHqbn8DvruHw7iw';

        var map = new mapboxgl.Map({
            container: 'mapboxSingle',
            style: 'mapbox://styles/blackdesk/ckq9m676a0skt18nuuc93knpv',
            center: markerPosition,
            maxZoom: 18,
            zoom: 12,
        });

        var el = document.createElement( 'div' );
        el.className = 'marker';
        el.style.backgroundImage = 'url(/wp-content/themes/vink/resources/images/marker-single.svg)';
        el.style.width = '50px';
        el.style.height = '50px';
        el.style.marginTop = '-15px';
        el.backgroundSize = 'cover';

        new mapboxgl.Marker(el)
        .setLngLat( markerPosition )
        .addTo( map );

        map.on( 'load', function() {
            map.resize();
        });
    }

}
